/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const StationsFiltersTypeEnum = {
    STATION_TYPE: "STATION_TYPE"
} as const;

export type StationsFiltersTypeEnumKey = (typeof StationsFiltersTypeEnum)[keyof typeof StationsFiltersTypeEnum];

export const StationsFiltersValueEnum = {
    STANDALONE: "STANDALONE",
    HEADER: "HEADER",
    REPEATER: "REPEATER",
    AFFILIATE: "AFFILIATE"
} as const;

export type StationsFiltersValueEnumKey = (typeof StationsFiltersValueEnum)[keyof typeof StationsFiltersValueEnum];

export const StationsFiltersTypeEnum2 = {
    STATION_GROUP: "STATION_GROUP"
} as const;

export type StationsFiltersTypeEnum2Key = (typeof StationsFiltersTypeEnum2)[keyof typeof StationsFiltersTypeEnum2];

export const StationsFiltersTypeEnum3 = {
    STATION_INDIVIDUAL: "STATION_INDIVIDUAL"
} as const;

export type StationsFiltersTypeEnum3Key = (typeof StationsFiltersTypeEnum3)[keyof typeof StationsFiltersTypeEnum3];

/**
 * StreamQualityReportRequest
*/
export type StreamQualityReportBodyDto = {
    /**
     * @description Station filters (GIP-style). Empty array resolves to all stations for the authenticated client. On GET, pass a JSON string encoding the array.
     * @type array
    */
    stationsFilters: ({
        /**
         * @type string
        */
        type: StationsFiltersTypeEnumKey;
        /**
         * @type string
        */
        value: StationsFiltersValueEnumKey;
    } | {
        /**
         * @type string
        */
        type: StationsFiltersTypeEnum2Key;
        /**
         * @type string, uuid
        */
        value: string;
    } | {
        /**
         * @type string
        */
        type: StationsFiltersTypeEnum3Key;
        /**
         * @type string, uuid
        */
        value: string;
    })[];
    /**
     * @type string, date-time
    */
    from: string;
    /**
     * @type string, date-time
    */
    to: string;
};